import ApiDocumentGql, {DocumentAdvancedJson} from "../../../../gd/api/graphql/document"
import asyncSessionLoader from "../../../../gd/data/async-session-loader"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import Document from "../../../../model2/doc/document"
import EntitySelectorItem from "../../glist/item"
import {matchesSearch} from "../functions/rows"

// const debug = "entitySelectorLoadDocumentItems"
const debug = false

// Rows for the Document tab, off `documentsUds`.
//
// Deliberately unscoped: the tab lists every document the viewer can see, even
// when the selector itself opens inside a project (the mention popover does).
// A document is picked by name, and the one being mentioned is usually not in
// the project being typed in. Pass `documentsUds` a `projectIds` input to
// narrow it.
export async function entitySelectorLoadDocumentItems(search: string): Promise<EntitySelectorItem[]> {

    const rows = await ApiDocumentGql.documentsUds().promise()

    // The input has no name filter, so the search is ours to apply.
    const visible = _.filter(rows, (row: DocumentAdvancedJson) => {
        return !row.isDeleted && matchesSearch(row.name, search)
    })

    debug && console.log(debug, 'loaded', rows.length, '->', visible.length)

    // Without this the project chips silently vanish: `GDProjectName` reads
    // `gd.session.projects`, and a document can sit in a project the session has
    // never loaded.
    await asyncSessionLoader(gd.session.findMissing({
        projects    : _.uniq(_.compact(_.map(visible, 'projectId'))),
        noteTypes   : _.uniq(_.compact(_.map(visible, 'noteTypeId'))),
    }))

    // The glist's own `sortBy`/`defaultSortBy` (see `../../glist/module.ts`)
    // orders these by date, so `documentsUds`'s own order doesn't matter here.
    return _.map(visible, documentToItem)
}

// `momentUpdated` is the column, falling back to creation for a document nobody
// has touched since -- the backend leaves it null rather than copying it.
function documentToItem(json: DocumentAdvancedJson): EntitySelectorItem {
    const datetime = json.momentUpdated || json.momentCreated

    return new EntitySelectorItem({
        entity      : new Document(json),
        title       : json.name,
        date        : datetime ? DatetimeUtils.datetimeToMoment(datetime) : null,
        projectId   : json.projectId,
    })
}
